import {removeServiceFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceKeys, serviceMutationKeys} from "../../../../../service-keys";

export function removeServiceFunctionMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: serviceMutationKeys.removeServiceFunction,
    mutationFn: (functionId: string) => removeServiceFunction(id, functionId),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceKeys.detail(id)}),
        client.invalidateQueries({queryKey: serviceKeys.lists()}),
      ]);
    },
  });
}
